import React, { useState } from 'react';
import ReportUserModal from './ReportUserModal';

/**
 * Compact overflow (kebab) menu whose only action today is "Report". Drop it
 * anywhere a user is shown outside chat (match cards, Discover profiles) to give
 * a report entry point without an existing conversation. Self-contained: owns
 * its menu + modal state and embeds the shared ReportUserModal.
 */

interface ReportMenuButtonProps {
  userId?: string;
  name?: string;
  conversationId?: string;
  connected?: boolean;
  className?: string;
}

const ReportMenuButton = ({
  userId,
  name,
  conversationId,
  connected,
  className,
}: ReportMenuButtonProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showReport, setShowReport] = useState(false);

  if (!userId) return null;

  return (
    <div className={`relative ${className ?? ''}`}>
      <button
        type='button'
        aria-label='More options'
        onClick={(e) => {
          e.stopPropagation();
          setShowMenu((v) => !v);
        }}
        className='p-1.5 text-body-300 hover:text-body-500 rounded-full hover:bg-gray-100 transition-colors'
      >
        <svg width='18' height='18' viewBox='0 0 20 20' fill='currentColor'>
          <circle cx='10' cy='4' r='1.5' />
          <circle cx='10' cy='10' r='1.5' />
          <circle cx='10' cy='16' r='1.5' />
        </svg>
      </button>
      {showMenu && (
        <>
          <div
            className='fixed inset-0 z-40'
            onClick={(e) => {
              e.stopPropagation();
              setShowMenu(false);
            }}
          />
          <div className='absolute right-0 top-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50 w-40'>
            <button
              type='button'
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(false);
                setShowReport(true);
              }}
              className='w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2'
            >
              <svg
                width='15'
                height='15'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
              >
                <path d='M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' />
                <line x1='4' y1='22' x2='4' y2='15' />
              </svg>
              Report
            </button>
          </div>
        </>
      )}
      <ReportUserModal
        open={showReport}
        reportedUserId={userId}
        reportedName={name}
        conversationId={conversationId}
        connected={connected}
        onClose={() => setShowReport(false)}
      />
    </div>
  );
};

export default ReportMenuButton;
